import { tsl_loggtyp } from './Generated/tsl_loggtyp';

export const ContactAttemptTypeText: { [key in tsl_loggtyp]: string } = {
  [tsl_loggtyp.Epost]: 'E-post',
  [tsl_loggtyp.Telefonsamtal]: 'Telefonsamtal',
  [tsl_loggtyp.SMS]: 'SMS',
  [tsl_loggtyp.Videosamtal]: 'Videosamtal',
  [tsl_loggtyp.Postalttelefonepostsaknas]: 'Avsluta - Telefon/e-post saknas',
  [tsl_loggtyp.PostaltAvvaktakomplettering]: 'Avsluta - Avvakta komplettering',
  [tsl_loggtyp.PostaltJagskickarbrev]: 'Postalt - Manuellt',
  [tsl_loggtyp.VlkomstbrevUnder40]: 'Välkomstbrev under 40 år',
  [tsl_loggtyp.Vlkomstbrevver40]: 'Välkomstbrev över 40 år',
  [tsl_loggtyp.PostaltKonkurs]: 'Postalt - Konkurs',
};
